<section>
  @if (afterDraw$ | async) {
    @if (isNullOrUndefined(selectedSegmentIndex) && isDefined(labelCoordinates[0])) {
      <app-doughnut-chart-label class="position-absolute"
                                [label]="positionsOverview[0].symbol"
                                [labelColor]="colors[0]"
                                [percentage]="volume
                                  ? positionsOverview[0]?.tradingVolumePercentage
                                  : positionsOverview[0]?.tradesCountPercentage"
                                [style]="'left:' + labelCoordinates[0].x + 'px; top:' + labelCoordinates[0].y + 'px;'"
                                (labelClick)="onLabelClicked($event)" />
    }
    @if (isNullOrUndefined(selectedSegmentIndex) && isDefined(labelCoordinates[1])) {
      <app-doughnut-chart-label class="position-absolute"
                                [label]="positionsOverview[1].symbol"
                                [labelColor]="colors[1]"
                                [percentage]="volume
                                  ? positionsOverview[1]?.tradingVolumePercentage
                                  : positionsOverview[1]?.tradesCountPercentage"
                                [style]="'left:' + labelCoordinates[1].x + 'px; top:' + labelCoordinates[1].y + 'px;'"
                                (labelClick)="onLabelClicked($event)" />
    }
    @if (isNullOrUndefined(selectedSegmentIndex) && isDefined(labelCoordinates[2])) {
      <app-doughnut-chart-label class="position-absolute"
                                [label]="positionsOverview[2].symbol"
                                [labelColor]="colors[2]"
                                [percentage]="volume
                                  ? positionsOverview[2]?.tradingVolumePercentage
                                  : positionsOverview[2]?.tradesCountPercentage"
                                [style]="'left:' + labelCoordinates[2].x + 'px; top:' + labelCoordinates[2].y + 'px;'"
                                (labelClick)="onLabelClicked($event)" />
    }
    @if (isNullOrUndefined(selectedSegmentIndex) && isDefined(labelCoordinates[3])) {
      <app-doughnut-chart-label class="position-absolute"
                                [label]="positionsOverview[3].symbol"
                                [labelColor]="colors[3]"
                                [percentage]="volume
                                  ? positionsOverview[3]?.tradingVolumePercentage
                                  : positionsOverview[3]?.tradesCountPercentage"
                                [style]="'left:' + labelCoordinates[3].x + 'px; top:' + labelCoordinates[3].y + 'px;'"
                                (labelClick)="onLabelClicked($event)" />
    }
    @if (isNullOrUndefined(selectedSegmentIndex) && isDefined(labelCoordinates[4])) {
      <app-doughnut-chart-label class="position-absolute"
                                [label]="positionsOverview[4].symbol"
                                [labelColor]="colors[4]"
                                [percentage]="volume
                                  ? positionsOverview[4]?.tradingVolumePercentage
                                  : positionsOverview[4]?.tradesCountPercentage"
                                [style]="'left:' + labelCoordinates[4].x + 'px; top:' + labelCoordinates[4].y + 'px;'"
                                (labelClick)="onLabelClicked($event)" />
    }
  }
  @if (baseCcy$ | async; as baseCcy) {
    <div class="body-text-container position-absolute">
      <div class="body-text">
        @if (isDefined(selectedSegmentIndex)) {
          <div class="symbol">
            {{ positionsOverview[Math.min(selectedSegmentIndex, 4)].symbol }}
          </div>
        }
        @if (!isDefined(selectedSegmentIndex) && volume) {
          <div class="symbol">
            {{ 'insights.total' | translate }}
          </div>
        }
        @if (isDefined(selectedSegmentIndex)) {
          <div>
            @if (volume) {
              <div class="total-value">
                <span class="main">
                  {{ positionsOverview[Math.min(selectedSegmentIndex, 4)].tradingVolume | thousandSuffixes }}
                </span>
                <span>{{ baseCcy }}</span>
              </div>
            } @else {
              <div class="total-value">
                <span class="main">
                  {{ positionsOverview[Math.min(selectedSegmentIndex, 4)].tradesCount }}
                </span>
                <span>{{ 'insights.labels.trades' | translate }}</span>
              </div>
            }
            <div class="percentage">
            @if (volume) {
              <span>
                {{ positionsOverview[Math.min(selectedSegmentIndex, 4)].tradingVolumePercentage | percentage }}
              </span>
              }
            @else {
              <span>
                {{ positionsOverview[Math.min(selectedSegmentIndex, 4)].tradesCountPercentage | percentage }}
              </span>
            }
            </div>
          </div>
        } @else {
          @if (volume) {
            <div class="total-value">
              <span class="main">{{ totalVolume | thousandSuffixes }}</span>
              <span>{{ baseCcy }}</span>
            </div>
          }
          @else {
            <div class="total-value nr-of-trades">
              <span class="main">{{ totalNumberOfTrades | number }}</span>
              <span>{{ 'insights.labels.trades' | translate }}</span>
            </div>
          }
        }
      </div>
    </div>
  }
  <canvas #doughnutChartCanvas
          class="doughnut-chart"></canvas>
</section>